import { createReducer } from '@reduxjs/toolkit';

import {
  fetchedServicesPassengersConcernedByCommunication,
  fetchServicesPassengersConcernedByCommunication,
} from './actions';
import { State } from './types';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
  data: undefined,
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(fetchServicesPassengersConcernedByCommunication, (state) => {
      state.status = 'loading';
      state.data = {
        ...state.data,
        message: undefined,
      };
    })
    .addCase(fetchedServicesPassengersConcernedByCommunication, (state, action) => {
      const { error, payload } = action;
      state.data = payload.data;
      if (error === true) {
        state.error = payload.error;
        state.status = 'error';
      } else {
        state.error = undefined;
        state.status = 'success';
      }
    })
);
